import { useCallback } from "react";
import { PageRoutes } from "../../../constants/routes";
import { useNavigation } from "../../../hooks/useNavigation";

export const useResetPasswordComplete = () => {
  const { navigateToPage } = useNavigation();

  const handleResetPasswordComplete = useCallback(() => {
    navigateToPage(PageRoutes.LOGIN);
  }, [navigateToPage]);

  return { handleResetPasswordComplete };
};
